import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '../../../Context';
import Flag from '../../../redux/flags/Flag';
import CollapsibleBlock from '../../../CollapsibleBlock';
import License from '../../../License';
import LegacyTextRenderer from '../../../TextRenderer/LegacyTextRenderer';
import DetailItem from './DetailItem';
import Subjects from '../_partials/Subjects';
import Facets from '../_partials/Facets';
import Tags from '../../../Tags';
import OriginalSize from './OriginalSize';
import Stats from '../../../SubmissionDetails/_partials/Stats';
import s from './Default.scss';
export var ExtendedDetails = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, deviationId = _b.deviationId, author = _b.author, publishedTime = _b.publishedTime, _c = _b.extended, _d = _c === void 0 ? {} : _c, subjectTags = _d.subjectTags, locationTag = _d.locationTag, categoryFacet = _d.categoryFacet, contentFacet = _d.contentFacet, typeFacet = _d.typeFacet, tags = _d.tags, license = _d.license, description = _d.description, exif = _d.exif;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    return (React.createElement(React.Fragment, null,
        React.createElement(Subjects, { className: s['subject'], subjectTags: subjectTags, locationTag: locationTag }),
        React.createElement(Flag, { condition: "remove_facets", fallbackRender: function () { return (React.createElement(Facets, { className: s['facets'], categoryFacet: categoryFacet, contentFacet: contentFacet, typeFacet: typeFacet })); } }),
        tags && (React.createElement("div", { className: s['tags'] },
            React.createElement(Tags, { key: "detailsTags-" + deviationId, tags: tags }))),
        React.createElement("div", { className: s['license'] },
            React.createElement(License, { license: license, author: author, publishedTime: publishedTime })),
        isMobile && (React.createElement("div", { className: s['stats'] },
            React.createElement(Stats, { deviation: deviation }))),
        description && (React.createElement(LegacyTextRenderer, { html: description, className: s['description'], theme: "extended-details" })),
        React.createElement(CollapsibleBlock, { buttonTextCollapsed: t('deviation.details.more'), buttonTextExpanded: t('deviation.details.less'), maxHeight: isMobile ? 120 : 160, buttonClassName: s['collapse-button'], className: s['collapsible-block'], shutterBlockClassName: s['collapsible-content'], fadeClassName: s['collapsible-fade'], showFade: true },
            React.createElement("div", { className: s['details'] },
                React.createElement(OriginalSize, { deviation: deviation }),
                exif && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: s['detail-group-title'] }, t('deviation.details.camera')),
                    exif.map(function (_a) {
                        var tag = _a.tag, value = _a.value;
                        return (React.createElement(DetailItem, { key: tag, name: tag, value: value, transPrefix: "exif." }));
                    })))))));
};
ExtendedDetails.displayName = 'ExtendedDetails';
export default ExtendedDetails;
//# sourceMappingURL=ExtendedDetails.js.map